import { Map } from "immutable";

import {
  compose,
  connect,
  toJS
} from "seneca-common/components/container-utils";
import {
  getUserFamilyName,
  getUserGivenName
} from "seneca-common/features/user/state";
import { validateString } from "seneca-common/utils/functions/validation/validateString";

import makeReduxFormWrapper from "../../containers/makeSignUpDetailsReduxFormWrapper";
import SignUpFormUserDetails from "./SignUpFormUserDetails";

const validateUserDetails = (valuesIn: Map<string, string>, props: any) => {
  const validationOutput = valuesIn.toJS() as {
    givenName: string;
    familyName: string;
    isSubscribedToMarketingEmails: boolean;
  };

  validationOutput.givenName = validateString(valuesIn.get("givenName"))!;
  validationOutput.familyName = validateString(valuesIn.get("familyName"))!;
  validationOutput.isSubscribedToMarketingEmails = false;

  return validationOutput;
};

const getUserDetailsFormDetails = (formValues: any, props: any) => {
  const details: any = {};
  const givenName = formValues.get("givenName");
  const familyName = formValues.get("familyName");
  const isSubscribedToMarketingEmails = formValues.get(
    "isSubscribedToMarketingEmails"
  );
  if (givenName) {
    details.givenName = givenName;
  }

  if (familyName) {
    details.familyName = familyName;
  }

  if (props.accountType) {
    details.type = props.accountType;
  }

  details.isSubscribedToMarketingEmails = isSubscribedToMarketingEmails;

  return details;
};

const reduxFormConnector = makeReduxFormWrapper(
  validateUserDetails,
  getUserDetailsFormDetails
);

const mapStateToProps = (state: any) => ({
  initialValues: {
    givenName: getUserGivenName(state),
    familyName: getUserFamilyName(state)
  }
});

const ConnectedSignUpFormUserDetails = compose(
  connect(mapStateToProps),
  // @ts-ignore
  toJS,
  reduxFormConnector
  // @ts-ignore
)(SignUpFormUserDetails);

export default ConnectedSignUpFormUserDetails;
